import type { FixedFooterProps } from "./interface";
import { FixedFooterContainer } from "./style";
import { useFixedFooter } from "./useFixedFooter";

export function FixedFooter({
  children,
  pageRef,
  borderNone,
}: FixedFooterProps) {
  const { footerRef } = useFixedFooter(children, pageRef);

  return (
    <FixedFooterContainer ref={footerRef} borderNone={borderNone}>
      {children}
    </FixedFooterContainer>
  );
}
